import Icon from '@ant-design/icons';
import React from 'react';
import svg from './svg';

export const TrashIcon = (props?: any) => <Icon component={svg.TrashSvg} {...props} />;

export const FacebookIcon = (props: any) => <Icon component={svg.FacebookSvg} {...props} />;

export const DownIcon = (props?: any) => <Icon component={svg.DownSvg} {...props} />;

export const PrintIcon = (props?: any) => <Icon component={svg.PrintSvg} {...props} />;

export const ArrowLeftIcon = (props?: any) => <Icon component={svg.ArrowLeft} {...props} />;

export const DeliveryManIcon = (props?: any) => <Icon component={svg.DeliveryManSvg} {...props} />;

export const DeliveryCarIcon = (props?: any) => <Icon component={svg.DeliveryCarSvg} {...props} />;

export const EditIcon = (props?: any) => <Icon component={svg.EditSvg} {...props} />;

export const DoubleRightIcon = (props?: any) => <Icon component={svg.DoubleRightSvg} {...props} />;

export const DoubleLeftIcon = (props?: any) => <Icon component={svg.DoubleLeftSvg} {...props} />;

export const EmultipleIcon = (props?: any) => <Icon component={svg.EditSvg1} {...props} />;

export const PlusIcon = (props?: any) => <Icon component={svg.PlusSvg} {...props} />;

export const LayoutLeftMenuIcon = (props?: any) => (
    <Icon component={svg.LayoutLeftMenuSvg} {...props} />
);

export const NavOrderSvgIcon = (props?: any) => <Icon component={svg.NavOrderSvg} {...props} />;

export const EcommerceDeliveryIcon = (props?: any) => (
    <Icon component={svg.EcommerceDeliverySvg} {...props} />
);

export const BoxIcon = (props?: any) => <Icon component={svg.BoxSvg} {...props} />;
export const ActionUserIcon = (props?: any) => <Icon component={svg.ActionUserSvg} {...props} />;
export const ReportIcon = (props?: any) => <Icon component={svg.ReportSvg} {...props} />;
export const SettingIcon = (props?: any) => <Icon component={svg.SettingSvg} {...props} />;
export const ConnectIcon = (props?: any) => <Icon component={svg.ConnectSvg} {...props} />;
